export const COMMENT_ADD = "COMMENT_ADD";
export const COMMENT_UPDATE = "COMMENT_UPDATE";
export const COMMENT_REPLY = "COMMENT_REPLY";
export const COMMENT_LIKE = "COMMENT_LIKE";
export const COMMENT_UNDO_LIKE = "COMMENT_UNDO_LIKE";
export const COMMENT_DELETE = "COMMENT_DELETE";
export const ENTITY_COMMENT_LIST_SET = "ENTITY_COMMENT_LIST_SET";
export const ENTITY_COMMENT_LIST_UPDATE = "ENTITY_COMMENT_LIST_UPDATE";
export const ENTITY_COMMENT_LIST_REMOVE = "ENTITY_COMMENT_LIST_REMOVE";

export const COMMENT_MODAL_SHOW = "COMMENT_MODAL_SHOW";
export const COMMENT_MODAL_HIDE = "COMMENT_MODAL_HIDE";
